//============================================================================
// Name        : PreventAutofill.tsx
// Purpose     : Helper to inject fake inputs to prevent autofill
// Created     : 2020-02-25
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

// tslint:disable-next-line: no-unused-expression
/** @jsx jsx */ jsx;
import { jsx } from "@emotion/core";
import React from "react";

export default class PreventAutofill extends React.Component<object, object> {
    render() {
        return (
            <React.Fragment>
                <input type="email" name="email" css={{ display: "none" }} />
                <input type="password" name="password"  css={{ display: "none" }} />
            </React.Fragment>
        );
    }
}
